import { DialogActions, MuiThemeProvider } from "@material-ui/core";
import { CircularProgress, Dialog, TextField } from "@material-ui/core";
import closeLogo from "../../assets/img/closeIcon.svg";
import React from "react";
import SingleEntryRow from "./SingleEntryRow";
import { useState } from "react";
import { useEffect } from "react";
import { getClassInfo } from "../../utils/authentication-access";
import BaseService from "../../store/services/base.service";
import { CLASSES } from "../../utils";

function JoinClassPopup(props) {
  const [intervalId, setIntervalId] = useState("");
  const [boards, setBoards] = useState([]);

  useEffect(() => {
    if (!props.showJoinClassPopup) {
      clearInterval(intervalId);
      setIntervalId("");
    } else {
      setIntervalId(
        setInterval(() => {
          const classes = JSON.parse(localStorage.getItem("classes"));
          classes.forEach(async (classInfo) => {
            const url = CLASSES.getLiveBoards(classInfo.kneuraId);
            const res = await new BaseService().makeGetRequestGeneric(url);
            if (res.length) setBoards([...res, ...boards]);
          });

        }, 5000),
      );
    }
  }, [props.showJoinClassPopup]);

  return (
    <MuiThemeProvider>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        className="overlay"
        open={props.showJoinClassPopup}
        onClose={props.closeJoinClassPopup}
        bodyStyle={{ padding: "unset" }}
      >
        <div className="dialog-modal-header bg-dm-modal">
          <div />
          <div className="text-center">
            <img
              className="close-icon hover"
              src={closeLogo}
              alt="Close"
              // style={{ visibility: "hidden" }}
              onClick={props.closeJoinClassPopup}
            />
          </div>
        </div>
        <div
          className="modal-card"
          style={{ display: "grid", gridRowGap: "10px" }}
        >
          {/* <div className="modal-title">{"Create a Lesson"}</div> */}
          <div
            className="digital-modal-subtitle"
            style={{ justifySelf: "center" }}
          >
            {"Searching for current live classes"}
          </div>
          <CircularProgress
            size={80}
            thickness={5}
            color={"#0074E4"}
            style={{ justifySelf: "center" }}
          />
          {/* <SingleEntryRow type="LIVE_CLASS" />
          <SingleEntryRow type="THIRD_PARTY" /> */}
          {boards.map((board) => (
            <SingleEntryRow
              type={"LIVE_CLASS" || board.type}
              url={board.url}
              flowId={board.id}
              name={board.name}
            />
          ))}
          {/* <DialogActions>
            <button
              className="btn-button-blank"
              onClick={props.closeJoinClassPopup}
            >
              {"Cancel"}
            </button>
          </DialogActions> */}
        </div>
      </Dialog>
    </MuiThemeProvider>
  );
}

export default JoinClassPopup;
